import { Box } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { StrategySelectorEmployee, StrategySelectorTeam, StrategyType } from './utils/interfaces'
import { getStrategyOptions } from './utils/strategyUtils'

interface StrategySelectorProps {
  strategyValue: StrategyType | undefined
  onStrategyChange: (value: StrategyType) => void
  onEmployeeSelect: (selection: EntitySelectEntity[] | EntitySelectEntity | null) => void
  onTeamSelect: (selection: EntitySelectEntity[] | EntitySelectEntity | null) => void
  selectedEmployees: Array<{ id: number; name: string; avatar?: string }>
  selectedTeams: Array<{ id: number; name: string }>
  availableEmployees: Array<StrategySelectorEmployee>
  availableTeams: Array<StrategySelectorTeam>
  isLoading: boolean
  strategyOptions: { label: string; value: string }[]
}

export const StrategySelector = ({
  strategyValue,
  onStrategyChange,
  onEmployeeSelect,
  onTeamSelect,
  selectedEmployees,
  selectedTeams,
  availableEmployees,
  availableTeams,
  isLoading,
  strategyOptions,
}: StrategySelectorProps) => {
  const strategyUIType = strategyValue ? getStrategyOptions(strategyValue).ui_type : undefined

  return (
    <Box gap="s8" width="full">
      <F0Select
        size="md"
        label="Strategy selector"
        hideLabel
        value={strategyValue}
        onChange={onStrategyChange}
        options={strategyOptions}
        placeholder={undefined}
      />

      {strategyUIType === 'manual_selected_employees' && (
        <EntitySelect
          label={i18n.t('workflows.sidepanel.approval.strategies.selectors.employees')}
          hideLabel
          size="md"
          loading={isLoading}
          entities={availableEmployees.map((emp) => ({
            id: emp.id,
            name: emp.fullName,
            avatar: buildUrl(emp.avatar?.url),
            expanded: false,
          }))}
          notFoundSubtitle={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_not_found_subtitle'
          )}
          notFoundTitle={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_not_found_title'
          )}
          onGroupChange={() => {}}
          onItemExpandedChange={() => {}}
          onSelect={onEmployeeSelect}
          searchPlaceholder={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_search_placeholder'
          )}
          selectedEntities={selectedEmployees}
          selectedLabel={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_selected_label'
          )}
          singleSelector={false}
          placeholder={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_placeholder'
          )}
          selectedItemsCopy={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_selected_copy'
          )}
          groups={[]}
          selectedGroup="all"
          clearLabel={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_clear_label'
          )}
          selectAllLabel={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.employees_select_all_label'
          )}
        />
      )}

      {strategyUIType === 'team' && (
        <EntitySelect
          label={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams')}
          hideLabel
          size="md"
          loading={isLoading}
          entities={availableTeams.map((team) => ({
            id: team.id,
            name: team.name,
            expanded: false,
          }))}
          notFoundSubtitle={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_not_found_subtitle'
          )}
          notFoundTitle={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_not_found_title'
          )}
          onGroupChange={() => {}}
          onItemExpandedChange={() => {}}
          onSelect={onTeamSelect}
          searchPlaceholder={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_search_placeholder'
          )}
          selectedEntities={selectedTeams}
          selectedLabel={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_selected_label'
          )}
          singleSelector
          placeholder={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_placeholder'
          )}
          selectedItemsCopy={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_selected_copy'
          )}
          groups={[]}
          selectedGroup="all"
          clearLabel={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams_clear_label')}
          selectAllLabel={i18n.t(
            'workflows.sidepanel.approval.strategies.selectors.teams_select_all_label'
          )}
        />
      )}
    </Box>
  )
}
